const ɵ0 = { scope: "draganddropfile" };
export class DragAndDropFileModule {
}
export { ɵ0 };
